// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { ScLabsAreaId, ScLabsAreaRoutes } from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  ScLabsAreaNavigation,
  ScLabsAreaNavigationIcon,
} from './ScLabsAreaNavigation'

const LazyScLabsComponent = lazy(() => import('./ScLabsArea'))

const ScLabsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyScLabsComponent />
  </SuspenseLoadingWrapper>
)

export const ScLabsArea = {
  id: ScLabsAreaId,
  requiredRight: BoumRight.AREA_SC_LABS,
  Icon: ScLabsAreaNavigationIcon,
  NavigationComponent: ScLabsAreaNavigation,
  route: {
    path: ScLabsAreaRoutes.route,
    component: ScLabsComponent,
  },
}
